import { RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  '& .chipItem': {
    '&.MuiChip-root': {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 600,
      color: theme.palette.common.white,
      borderRadius: theme.spacing(124.8),
      border: `1px solid${theme.palette.overlay[1]}`,
      height: theme.spacing(5),
      padding: theme.spacing(1.5, 1.75),
      '&:focus': {
        backgroundColor: 'transparent',
      },
      '&.Selection': {
        border: `1px solid${theme.palette.common.white}`,
      },
    },
    '& .RGChipIcon': {
      fontSize: theme.spacing(2),
    },
    '& .MuiChip-label': {
      position: 'relative',
      top: theme.spacing(0.25),
    },
  },

  '&.RadioGroupFilter': {
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
    '& .MuiFormControl-root': {
      paddingRight: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(2),
        display: 'block',
      },
    },
  },
}));
export default StyledRadioGroup;
